import React from 'react'; 
import { useNavigate } from 'react-router-dom';
import bedImg from '../../../img/beds.jpeg';  // Agrega la importación de la imagen aquí

const ProductosCamas = () => {
  const navigate = useNavigate();

  const productosCamas = [
    {
      numeroCama: "B001",
      descripcion: "Elegante estructura de bed con acabado en madera clásica, perfecta para cualquier dormitorio.",
      imagen: bedImg  // Usa la variable de la imagen aquí
    },
  ];

  const handleContactClick = () => {
    navigate('/es/contact');
  };

  return (
    <div className="container mx-auto px-4 py-20">
      <h1 className="text-3xl font-bold text-center mb-8 font-montserrat">Colección de Beds</h1>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {productosCamas.map((producto) => (
          <div
            className="bg-white rounded-lg shadow-md overflow-hidden transform transition-transform duration-300 hover:scale-105 cursor-pointer flex flex-col h-full"
            key={producto.numeroCama}
          >
            <img
              src={producto.imagen}
              alt={`Beds ${producto.numeroCama}`}
              className="w-full h-48 object-cover"
            />
            <div className="p-4 flex flex-col flex-grow">
              <h5 className="text-xl font-semibold text-gray-800 mb-2">
                Beds {producto.numeroCama}
              </h5>
              <p className="text-sm text-gray-600 leading-relaxed flex-grow">
                {producto.descripcion}
              </p>
            </div>
          </div>
        ))}

        {/* Tarjeta informativa */}
        <div
          className="md:col-span-2 bg-emerald-800 rounded-lg shadow-md p-6 flex flex-col justify-between cursor-pointer hover:bg-emerald-700 transition-colors duration-300"
          onClick={handleContactClick}
        >
          <div>
            <h5 className="text-xl font-bold text-emerald-50 mb-4">¿Necesitas más información?</h5>
            <p className="text-emerald-100 mb-4">
              ¿Estás interesado en nuestras camas? ¿Quieres discutir diseños personalizados o recibir una cotización? 
              Nuestro equipo está listo para ayudarte a encontrar la cama perfecta para tu proyecto.
            </p>
            <p className="text-emerald-100">
              Para ver la lista completa de productos, por favor regístrate para obtener tu token de acceso (clave).
            </p>
          </div>
          <div className="mt-4">
            <span className="text-emerald-50 font-semibold hover:underline">
              Contáctanos →
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductosCamas;
